// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0cb6d755","498":"880048b5","703":"8ae0d00e"}[chunkId] + ".chunk.js";
};